function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInProgress({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E9EBF0",
    style: {
      fill: "#E9EBF0",
      fill: "color(display-p3 0.9137 0.9216 0.9412)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2996 23.2996C23.2996 24.5996 21.6996 25.4996 19.9996 25.4996C16.9996 25.4996 14.5996 23.0996 14.5996 20.0996C14.5996 17.0996 16.9996 14.5996 19.9996 14.5996C21.1996 14.5996 22.3996 14.9996 23.2996 15.6996",
    stroke: "#0B1C56",
    style: {
      stroke: "#0B1C56",
      stroke: "color(display-p3 0.0431 0.1098 0.3373)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3992 19.4C26.062 19.4 26.5992 18.8627 26.5992 18.2C26.5992 17.5373 26.062 17 25.3992 17C24.7365 17 24.1992 17.5373 24.1992 18.2C24.1992 18.8627 24.7365 19.4 25.3992 19.4Z",
    stroke: "#0B1C56",
    style: {
      stroke: "#0B1C56",
      stroke: "color(display-p3 0.0431 0.1098 0.3373)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 30C25.5228 30 30 25.5228 30 20C30 14.4772 25.5228 10 20 10C14.4772 10 10 14.4772 10 20C10 25.5228 14.4772 30 20 30Z",
    stroke: "#0B1C56",
    style: {
      stroke: "#0B1C56",
      stroke: "color(display-p3 0.0431 0.1098 0.3373)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/in-progress.4e255a91a5de0dffc844c314c2d0ec8c.svg";
export { ForwardRef as ReactComponent };